const APIS = {
  INVOICE: "/invoiceservice/api/merchant-invoice/",
  CLIENT_SETTING:"projectsettingsservice/api/configuration/",
  USER_PROFILE: "logisticservice/api/user-profile/",
  BUSINESS_PROFILE: "/logisticservice/api/business-profile/",
  PAYMENT_METHOD:"/invoice/payment-method/",
  MAKE_PAYMENT:"/invoice/make-payment/",
  
};

export default APIS;